<template lang="pug">
transition(@enter="enter" @leave="leave")
  .l-map-item-object(
    v-if="show"
    :style="styleObject"
  )
    .l-map-item-object__wrap(:style="styleObjectWrap")
      .l-map-item-object__wrap__obj(
        :style="styleObjectObj"
        ref="obj"
      )
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-item-object
  pos(0,0,5)
  // pointer-events none
  &__wrap
    position absolute
    overflow hidden
    &__obj
      position absolute
      background-size cover
</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent,onMounted,computed,ref} from "vue"
import { useStore } from '@/store'
import Util from '../../lib/util'

export default defineComponent({
  name:'MapItemObject',

  props:{
    maptype:{
      type:Number,
      default: 1
    },
    mapdata:{
      type:Object,
      default: function() {
        return {}
      }
    }
  },

  setup(props, context) {
    const store = useStore()
    const obj = ref(null)
    const show = computed(()=>{
      if(store.ui.state.hotoke){
        //仏
        if(props.mapdata.hotoke){
          return true
        } else {
          return false
        }
      } else {
        //季節
        if(props.mapdata.season.indexOf(store.ui.state.season) > -1) {
          return true
        } else {
          return false
        }
      }
    })
    const styleObject = computed(()=>{
      // console.log(props.mapdata);
      const coordinate = props.mapdata.coordinate.split(",")
      return {
        left: coordinate[0] + 'px',
        top: coordinate[1] + 'px'
      }
    })
    const styleObjectWrap = computed(()=>{
      const width = props.mapdata.retina ? props.mapdata.img_width/2 :  props.mapdata.img_width
      const height = props.mapdata.retina ? props.mapdata.img_height/2 :  props.mapdata.img_height
      const origin = props.mapdata.origin.split(" ")
      let left = 0
      let top = 0

      const calcorigin = (value,size)=>{
        if(value == 'center'){
          return size / 2
        } else if(value == 'left'){
          return 0
        } else if(value == 'right'){
          return size
        } else if(value == 'top'){
          return 0
        } else if(value == 'bottom'){
          return size
        } else {
          return value.replace('px','')
        }
      }
      if(origin.length == 2){
        left = calcorigin(origin[0],width)
        top = calcorigin(origin[1],height)
      }
      return {
        width:width + 'px',
        height:height + 'px',
        left:-left + 'px',
        top:-top + 'px'
      }
    })
    const styleObjectObj = computed(()=>{
      const url = store.config.STATIC_MAPDATA_IMG_PATH + props.mapdata.img
      const width = props.mapdata.retina ? props.mapdata.img_width/2 :  props.mapdata.img_width
      const height = props.mapdata.retina ? props.mapdata.img_height/2 :  props.mapdata.img_height
      return {
        backgroundImage:'url('+ url +')',
        width:width + 'px',
        height:height + 'px',
      }
    })

    const enter = (el, done)=> {
      let delay = store.ui.state.kumoMotionDurationAll/1000
      gsap.fromTo(el,
        {opacity:0},
        {opacity:1,duration:0.1,delay:delay,onComplete:()=>{
          done()
        }}
      )
    }
    const leave = (el, done)=> {
      let delay = store.ui.state.kumoMotionDurationAll/1000
      gsap.to(el,
        {opacity:0,duration:0.1,delay:delay,onComplete:()=>{
          done()
        }}
      )
    }

    onMounted(async ()=>{
      if(obj.value){
        let delay = (store.ui.state.hotoke ? store.ui.state.kumoMotionDurationAll : store.ui.state.mapytypeMotionDurationAll) / 1000
        if(store.ui.state.tutorial.through){
          delay = 0.0
        }
        if(store.ui.state.hotoke){
          delay += 0.7
        }
        if(!store.ui.state.init){
          await (async () => {
            for await (let i of Array(20)) {
              await Util.sleep(100)
              if(store.ui.state.init) break
            }
          })()
        }

        delay += props.mapdata._order * store.ui.state.mapytypeMotionDelayTimeOne / 1000
        gsap.fromTo(obj.value,
          {y:'100%'},
          {y:'0%',duration:0.5,delay:delay,ease:'power2.out'}
        )
      }
    })



    return{
      show,
      styleObject,
      styleObjectWrap,
      styleObjectObj,
      enter,
      leave,
      obj
    }
  }
})
</script>
